import { _ } from "../polyglot/polyglot.js";
import { widget } from "@foretagsplatsen/widgetjs";

/**
 * This widget encapsulates the rendering of the client-side
 * not-found pages, used in all applications.
 *
 * @param {{}} [spec] - parameter object
 * @param {{}} [my] - protected fields holder
 * @return {*}
 */
function routeNotFoundWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	that.renderContentOn = function (html) {
		html.div(
			{ klass: "row" },
			html.div(
				{ class: "col-sm-4 col-sm-offset-4 text-center" },
				html.p(
					{ klass: "lead" },
					_(
						"If clicking on a link brought you here, please report it to us.",
					),
				),
				html.p(
					{ klass: "lead" },
					_("Please go {link: back} in history", {
						link: function (back) {
							return function (html) {
								html.a(back).click(() => {
									window.history.back();
								});
							};
						},
					}),
				),
			),
		);
	};

	return that;
}

export default routeNotFoundWidget;
